import React, {useEffect, useState, useRef} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Button, Checkbox, Collapse, Empty, Form, Input, Modal, Result, Select, Steps} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle, faCheckSquare, faPlus, faSquareMinus, faTrash} from '@fortawesome/free-solid-svg-icons';
import {browserName, browserVersion, osName, osVersion} from 'react-device-detect';
import BasketList from './basket/BasketList';
import BasketInfo from './basket/BasketInfo';
import {connect, useSelector} from 'react-redux';
import {reduxStore} from '../../../services/redux/ReduxIndex';
import DeliveryPointModal from './basket/DeliveryPointModal';
import GoogleMaps from '../../partials/GoogleMaps';
import AddressModal from './basket/AddressModal';
import MaskedInput from 'antd-mask-input';
import HelperGeneral from '../../../helpers/HelperGeneral';
import {trans} from '../../../helpers/HelperGlobal';
import UserInfo from '../../auth/UserInfo';
import CreditCardForm from '../../partials/CreditCardForm';
import Api from '../../../services/Api';
import {setGlobalConfiguration, setGlobalSpinner} from '../../../services/redux/actions/GeneralAction';
import moment from 'moment';
import _ from "lodash";
import {useLocation} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";
import {setBasketList} from "../../../services/redux/actions/BasketAction";

const {Panel} = Collapse;
const {Step} = Steps;
const {Option} = Select;

const BasketView = (props) => {
    // const {basketList} = reduxStore.getState().BasketReducer;
    const basketList = useSelector(state => state.BasketReducer.basketList);
    const {settings} = reduxStore.getState().GeneralReducer;
    const [step, setStep] = useState(0);
    const [deliveryPointShow, setDeliveryPointShow] = useState(false);
    const [deliveryPointItem, setDeliveryPointItem] = useState({});
    const [addressShow, setAddressShow] = useState(false);
    const [pharmacies, setPharmacies] = useState([]);
    const [pharmaciesMap, setPharmaciesMap] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [addressItem, setAddressItem] = useState({});
    const [invoiceChecked, setInvoiceChecked] = useState(true);
    const [DeliveryType, setDeliveryType] = useState(undefined);
    const [selectedPharmacy, setSelectedPharmacy] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [selectedInvoiceAddress, setSelectedInvoiceAddress] = useState(null);
    const [loading, setLoading] = useState([]);
    const [cities, setCities] = useState([]);
    const [counties, setCounties] = useState([]);
    const [selectedCityId, setSelectedCity] = useState('00000000-0000-0000-0000-000000000000');
    const [selectedCountyId, setSelectedCounty] = useState('00000000-0000-0000-0000-000000000000');
    const [refreshAddress, setRefreshAddress] = useState(false);
    const [searchPharmacyName, setSearchPharmacyName] = useState('');
    const [coords, setCoords] = useState({});
    // const [basketBrandIds, setBasketBrandIds] = useState([]);
    const [paymentErrorMessage, setPaymentErrorMessage] = useState(null);
    const [paymentCompletedOrderNumber, setPaymentCompletedOrderNumber] = useState("");
    const [allPaymentMethods, setAllPaymentMethods] = useState(null);
    const [deliveryInfo, setDeliveryInfo] = useState({});
    const [orderNumber, setOrderNumber] = useState(null);
    const emptyBasketAlertShownRef = useRef(false);

    const getCounties = (cityId) => {
        setSelectedCity(cityId);
        setLoading(true);
        setCounties([]);
        Api.getCounties(cityId).then((e) => {
            setLoading(false);
            setCounties(e?.data);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }

    const getCities = () => {
        setLoading(true);

        Api.getCitiesAll().then((e) => {
            setLoading(false);
            setCities(e?.data);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }

    const getAddress = () => {
        const user = UserInfo.info();

        Api.getAddressAll(user?.id).then((e) => {
            setAddresses(e?.data ?? []);
        }).catch(e => {
            HelperGeneral.alert(e)
        })
    }

    const deleteAddress = (addressId) => {
        setTimeout(() => {
            Modal.confirm({
                type: 'warning',
                content: 'Adresinizi silmek istediğinize emin misiniz?',
                okText: 'Evet',
                cancelText: 'Hayır',
                onOk() {
                    setGlobalSpinner(true);
                    Api.addressDelete(addressId).then(r => {
                        setGlobalSpinner(false);
                        getAddress();
                        setSelectedAddress(null);
                        setSelectedInvoiceAddress(null);
                    }).catch((e) => {
                        setGlobalSpinner(false);
                        HelperGeneral.alert(e);
                    })
                },
                onCancel() {
                    Modal.destroyAll();
                },
            })
        }, 100)
    }

    useEffect(() => {
        if (step === 0) {
            getCities();
            getAddress();
        }

        Api.getPaymentMethods().then((response) => {
            const allPaymentMethods = response?.data?.data || response?.data || [];
            const paymentMethod30 = allPaymentMethods.find(pm => pm?.id === 30);
            if (paymentMethod30) {
                setAllPaymentMethods(paymentMethod30);
            } else {
                setAllPaymentMethods({});
            }
        }).catch((error) => {
            console.error('Payment Methods Error:', error);
        });
    }, [])

    useEffect(() => {
        if (refreshAddress) {
            getAddress();
        }
        setRefreshAddress(false);
    }, [refreshAddress])

    useEffect(() => {
        const productCount = basketList?.products?.length ?? basketList?.length ?? 0;

        if (productCount < 1 && step !== 2) {
            if (!emptyBasketAlertShownRef.current) {
                emptyBasketAlertShownRef.current = true;
                HelperGeneral.alert("Sepetinizde ürün bulunmamaktadır.", "", "", '/home');
            }
        } else {
            emptyBasketAlertShownRef.current = false;

            if (basketList?.warningArray?.length > 0) {
                HelperGeneral.pageChange(props, '/home');
            }
        }
    }, [basketList])

    const onFinishStep1 = (values = {}) => {
        let user = UserInfo.info();
        let order = localStorage.getItem("orderInfo");
        order = order ? JSON.parse(order) : false;
        if (DeliveryType === 1) {
            localStorage.removeItem("orderInfo");
            if (selectedPharmacy === null) {
                return HelperGeneral.alert('Eczane Teslim noktası seçiniz', 'error');
            }
        } else if (DeliveryType === 2) {
            if (selectedAddress === null) {
                return HelperGeneral.alert('Adres seçiniz', 'error');
            }
            if (invoiceChecked === false && selectedInvoiceAddress === null) {
                return HelperGeneral.alert('Fatura adresi seçiniz', 'error');
            }
        } else {
            return HelperGeneral.alert('Teslim noktası seçiniz', 'error');
        }
        setTimeout(() => {
            const basketProducts = basketList?.products || [];
            const stockProducts = basketProducts.map(item => ({
                code: item.product_code,
                quantity: item.quantity
            }));

            setGlobalSpinner(true);

            // const isInvoiceAddressSame = selectedAddress === selectedInvoiceAddress;
            const isInvoiceAddressSame = true;

            Api.createOrder(allPaymentMethods?.encrypted_id, stockProducts, addresses, selectedAddress, selectedInvoiceAddress, isInvoiceAddressSame).then(res => {
                if (res?.data?.warningArray?.length > 0) {
                    HelperGeneral.alert(res?.data?.warningArray[0])
                    setGlobalSpinner(false)
                } else if (res?.data?.orderResult) {
                    setStep(2);
                    setOrderNumber(res?.data?.orderResult?.id ?? '-');
                    Api.getBasket().then((response) => {
                        if (response?.data.products?.length > 0) {
                            localStorage.setItem("basketList", JSON.stringify(response.data));
                            setBasketList(response.data);
                        } else {
                            localStorage.removeItem("basketList");
                            setBasketList([]);
                        }
                        Api.getCustomer().then(r2 => {
                            const {remember} = UserInfo.dataCheck();
                            UserInfo.setUserInfo(r2?.data, remember);
                            setGlobalSpinner(false)
                        }).catch((e) => {
                            HelperGeneral.alert(e);
                            setGlobalSpinner(false)
                        });
                    }).catch((e) => {
                        HelperGeneral.alert(e);
                        setGlobalSpinner(false)
                    });
                } else {
                    HelperGeneral.alert('Ürün satın alımında bir sorun oluştu!');
                    setGlobalSpinner(false)
                }
            }).catch((e) => {
                setGlobalSpinner(false)
                HelperGeneral.alert(e?.data?.message);
            })
        }, 100)
    }

    const collapseTitleRight = (title, key) => (
        <Row>
            {
                title?.length > 0 && (
                    <Col xs={9} className={'d-flex justify-content-end'}>
                        <span>{title}</span>
                    </Col>
                )
            }
            <Col xs={title?.length > 0 ? 3 : 12} className={'d-flex justify-content-end'}>
                <FontAwesomeIcon
                    icon={DeliveryType === key ? faCheckSquare : faSquareMinus}
                    style={{
                        fontSize: 22,
                        color: (DeliveryType === key ? '#FBBDA0' : 'gray'),
                    }}
                />
            </Col>
        </Row>
    )

    const user = UserInfo.info();

    user['phoneNumber'] = user?.mobilePhone ?? "";

    const addressList = (invoice = false) => {
        return (
            <Row className={(invoiceChecked && invoice ? 'd-none' : '')}>
                {
                    addresses?.map((v, i) => (
                        <Col xs={12} lg={4} className={'d-flex address-col'} key={i}>
                            <div
                                className={'address-box'}
                                onClick={() => {
                                    setDeliveryType(2);
                                    if (!invoice) setSelectedAddress(v?.id);
                                    else setSelectedInvoiceAddress(v?.id);
                                }}
                            >
                                <Row className={'d-flex'}>
                                    <Col xs={9} className={'mb-2'}>
                                        {v?.name + ' ' + v?.last_name}
                                    </Col>
                                    <Col xs={3} className={'text-end mb-2'}>
                                        {
                                            !invoice ?
                                                selectedAddress === v?.id ? <FontAwesomeIcon style={{fontSize: 19, color: '#FBBDA0'}} icon={faCheckCircle}/> : <span>Seç</span>
                                                : ''
                                        }
                                        {
                                            invoice ?
                                                selectedInvoiceAddress === v?.id ? <FontAwesomeIcon style={{fontSize: 19, color: '#FBBDA0'}} icon={faCheckCircle}/> : <span>Seç</span>
                                                : ''
                                        }
                                    </Col>
                                    <Col xs={12} className={'mb-2'}><b>{v?.title}</b></Col>
                                    <Col xs={12} className={'mb-2'}>{v?.address}</Col>
                                    <Col xs={12}>{v?.telephone}</Col>
                                    <Col xs={6} className={'mt-4 d-flex justify-content-start align-items-center'}>
                                        <a
                                            onClick={() => {
                                                setAddressItem(v)
                                                setAddressShow(true)
                                            }}
                                        >
                                            Düzenle
                                        </a>
                                    </Col>
                                    <Col xs={6} className={'mt-4 d-flex justify-content-end align-items-center'}>
                                        <a
                                            onClick={() => {
                                                deleteAddress(v.id)
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrash}/>
                                        </a>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    ))
                }
                {
                    addresses?.length < 3 && (
                        <Col xs={12} lg={4} className={'d-flex address-col'}>
                            <div
                                className={'address-box add'}
                                onClick={() => {
                                    setAddressItem({})
                                    setAddressShow(true)
                                }}
                            >
                                <Row className={'h-100'}>
                                    <Col xs={12} className={'d-flex align-items-end justify-content-center mb-2'}>
                                        <FontAwesomeIcon icon={faPlus}/>
                                    </Col>
                                    <Col xs={12} className={'d-flex align-items-start justify-content-center'}>
                                        Teslimat Adresi Ekle
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    )
                }
            </Row>
        )
    }

    return (
        <Container className={'mt-sm-4 mb-4 basket right-modal'}>
            <Row>
                <Col xs={12}>
                    <div className={'box step-box'}>
                        <Steps current={step === 2 ? 1 : 0}>
                            <Step title={"Teslimat Bilgileri"} className={'delivery-step'} description={""} onClick={() => (step !== 2 && step !== 3) && setStep(0)}/>
                            {/*<Step title={"Ödeme Bilgileri"} description={""}/>*/}
                            <Step title={"İşlem Sonucu"} description={""}/>
                        </Steps>
                    </div>
                </Col>
            </Row>
            {
                step === 0 && (
                    <Form
                        layout={"vertical"}
                        name={"step1"}
                        initialValues={user}
                        onFinish={(e) => {
                            if (DeliveryType === 1) {
                                return onFinishStep1(e)
                            }
                            return false
                        }}
                    >
                        <Row>
                            <Col xs={12} md={8}>
                                <div className={'box delivery-box'}>
                                    <h2>Teslimat Seçenekleri</h2>
                                    <Collapse
                                        accordion={true}
                                        onChange={(key) => {
                                            const _key = key !== undefined ? parseInt(key) : undefined
                                            setDeliveryType(_key)
                                            setSelectedAddress(null)
                                            setInvoiceChecked(true)
                                        }}
                                    >
                                        {/*{*/}
                                        {/*    settings?.isDeliveryToPharmacyActive && (*/}
                                        {/*        <Panel header="Eczaneden Teslim" key="1" extra={collapseTitleRight('Ücretsiz Teslim', 1)}>*/}
                                        {/*            <p>Siparişinizi Pazar günü hariç haftanın 6 günü saat 19:00’a kadar seçtiğiniz eczaneden teslim alabilirsiniz.</p>*/}
                                        {/*            <Row className={'row'}>*/}
                                        {/*                <Col xs={12} md={4} className={'mb-3'}>*/}
                                        {/*                    <Select*/}
                                        {/*                        placeholder={'Şehir Seçiniz'}*/}
                                        {/*                        className={'w-100'}*/}
                                        {/*                        loading={loading}*/}
                                        {/*                        onChange={(value) => {*/}
                                        {/*                            setSelectedCity(value)*/}
                                        {/*                            getCounties(value)*/}
                                        {/*                        }}*/}
                                        {/*                    >*/}
                                        {/*                        <option value="00000000-0000-0000-0000-000000000000">Seçiniz*/}
                                        {/*                        </option>*/}
                                        {/*                        {*/}
                                        {/*                            cities.map(*/}
                                        {/*                                (v, i) => (*/}
                                        {/*                                    <Option*/}
                                        {/*                                        value={v.cityId}>{v.name}</Option>*/}
                                        {/*                                ))*/}
                                        {/*                        }*/}
                                        {/*                    </Select>*/}
                                        {/*                </Col>*/}
                                        {/*                <div*/}
                                        {/*                    className={'col-12 col-md-4 mb-3'}>*/}
                                        {/*                    <Select*/}
                                        {/*                        placeholder={'İlçe Seçiniz'}*/}
                                        {/*                        className={'w-100'}*/}
                                        {/*                        loading={loading}*/}
                                        {/*                        onChange={(value) => {*/}
                                        {/*                            setSelectedCounty(value)*/}
                                        {/*                        }}*/}
                                        {/*                    >*/}
                                        {/*                        <option value="00000000-0000-0000-0000-000000000000">Seçiniz*/}
                                        {/*                        </option>*/}
                                        {/*                        {*/}
                                        {/*                            counties.map(*/}
                                        {/*                                (v, i) => (*/}
                                        {/*                                    <Option*/}
                                        {/*                                        value={v.countyId}>{v.name}</Option>*/}
                                        {/*                                ))*/}
                                        {/*                        }*/}
                                        {/*                    </Select>*/}
                                        {/*                </div>*/}
                                        {/*                <div*/}
                                        {/*                    className={'col-12 col-md-4 mb-3'}>*/}
                                        {/*                    <Input*/}
                                        {/*                        onKeyPress={(e) => {*/}
                                        {/*                            e.key === 'Enter' && e.preventDefault();*/}
                                        {/*                        }}*/}
                                        {/*                        onChange={(e) => {*/}
                                        {/*                            if (e?.target?.value.length > 4) {*/}
                                        {/*                                setSearchPharmacyName(e?.target?.value)*/}
                                        {/*                            } else {*/}
                                        {/*                                setSearchPharmacyName('')*/}
                                        {/*                            }*/}
                                        {/*                        }}*/}
                                        {/*                        placeholder="Eczane Ara"/>*/}
                                        {/*                </div>*/}
                                        {/*            </Row>*/}
                                        {/*            <div className={'row mt-4 mb-4'}>*/}
                                        {/*                <div*/}
                                        {/*                    className={'col-12 col-md-4 bg-gray'}>*/}
                                        {/*                    <h6>Teslim noktası*/}
                                        {/*                        seçiniz</h6>*/}
                                        {/*                    <ul className="list-map pharmacies">*/}
                                        {/*                        {*/}
                                        {/*                            pharmacies.map(*/}
                                        {/*                                (v, i) => (*/}
                                        {/*                                    <li*/}
                                        {/*                                        key={v.id}*/}
                                        {/*                                        id={"pharmacy-list-" + v.id}*/}
                                        {/*                                        className={`box ${selectedPharmacy === v.id && 'selected'}`}*/}
                                        {/*                                        onClick={() => v.clickEvent()}>*/}
                                        {/*                                        <a>*/}
                                        {/*                                            <h5>{v.accountName}</h5>*/}
                                        {/*                                            <p>{v.addressLine}</p>*/}
                                        {/*                                        </a>*/}
                                        {/*                                    </li>*/}
                                        {/*                                ))*/}
                                        {/*                        }*/}
                                        {/*                        {*/}
                                        {/*                            pharmacies < 1 && (*/}
                                        {/*                                <Empty*/}
                                        {/*                                    className={'mt-3'}*/}
                                        {/*                                    description={'Teslimat Noktası Bulunamadı'}*/}
                                        {/*                                />*/}
                                        {/*                            )*/}
                                        {/*                        }*/}
                                        {/*                    </ul>*/}
                                        {/*                    <DeliveryPointModal*/}
                                        {/*                        show={deliveryPointShow}*/}
                                        {/*                        showSend={(show) => {*/}
                                        {/*                            setDeliveryPointShow(*/}
                                        {/*                                show)*/}
                                        {/*                        }}*/}
                                        {/*                        selectedPharmacySend={(pharmacyId) => {*/}
                                        {/*                            setSelectedPharmacy(pharmacyId)*/}
                                        {/*                            const element = document.getElementById('pharmacy-list-' + pharmacyId);*/}
                                        {/*                            if (element) {*/}
                                        {/*                                element.scrollIntoView({*/}
                                        {/*                                    block: "center",*/}
                                        {/*                                    inline: "center"*/}
                                        {/*                                });*/}
                                        {/*                            }*/}
                                        {/*                        }}*/}
                                        {/*                        item={deliveryPointItem}*/}
                                        {/*                    />*/}

                                        {/*                </div>*/}
                                        {/*                <div*/}
                                        {/*                    className={'col-12 col-md-8'}>*/}
                                        {/*                    <GoogleMaps*/}
                                        {/*                        currentLocation={true}*/}
                                        {/*                        markers={pharmaciesMap}*/}
                                        {/*                        coords={(coords) => {*/}
                                        {/*                            setCoords(coords)*/}
                                        {/*                        }}*/}
                                        {/*                    />*/}
                                        {/*                </div>*/}
                                        {/*            </div>*/}
                                        {/*            <h6>Teslim Alacak Kişi*/}
                                        {/*                Bilgileri</h6>*/}

                                        {/*            <div className={'row mt-4'}>*/}
                                        {/*                <div*/}
                                        {/*                    className={'col-12 col-md-6'}>*/}
                                        {/*                    <Form.Item*/}
                                        {/*                        label="Adınız"*/}
                                        {/*                        name="name"*/}
                                        {/*                        rules={[*/}
                                        {/*                            {*/}
                                        {/*                                required: true,*/}
                                        {/*                            },*/}
                                        {/*                        ]}*/}
                                        {/*                    >*/}
                                        {/*                        <Input/>*/}
                                        {/*                    </Form.Item>*/}
                                        {/*                </div>*/}
                                        {/*                <div*/}
                                        {/*                    className={'col-12 col-md-6'}>*/}
                                        {/*                    <Form.Item*/}
                                        {/*                        label="Soyadınız"*/}
                                        {/*                        name="surname"*/}
                                        {/*                        rules={[*/}
                                        {/*                            {*/}
                                        {/*                                required: true,*/}
                                        {/*                            },*/}
                                        {/*                        ]}*/}
                                        {/*                    >*/}
                                        {/*                        <Input/>*/}
                                        {/*                    </Form.Item>*/}
                                        {/*                </div>*/}
                                        {/*                <div*/}
                                        {/*                    className={'col-12 col-md-6'}>*/}
                                        {/*                    <Form.Item*/}
                                        {/*                        name={'phoneNumber'}*/}
                                        {/*                        label="Telefon Numarası"*/}
                                        {/*                        rules={[*/}
                                        {/*                            () => ({*/}
                                        {/*                                required: true,*/}
                                        {/*                                message: 'Telefon numaranız gerekli bir alan',*/}
                                        {/*                                validator(_, value) {*/}
                                        {/*                                    const v = HelperGeneral.telephoneClear(value)*/}
                                        {/*                                    if (v.length === 12) {*/}
                                        {/*                                        return Promise.resolve()*/}
                                        {/*                                    }*/}
                                        {/*                                    return Promise.reject(new Error(trans('t10')))*/}
                                        {/*                                },*/}
                                        {/*                            })]}*/}

                                        {/*                    >*/}
                                        {/*                        <MaskedInput*/}
                                        {/*                            disabled={true}*/}
                                        {/*                            mask={'(\\+90)111-111-11-11'}*/}
                                        {/*                        />*/}
                                        {/*                    </Form.Item>*/}
                                        {/*                </div>*/}
                                        {/*                <div*/}
                                        {/*                    className={'col-12 col-md-6'}>*/}
                                        {/*                    <Form.Item*/}
                                        {/*                        label="E-posta Adresiniz"*/}
                                        {/*                        name="email"*/}
                                        {/*                        rules={[*/}
                                        {/*                            {*/}
                                        {/*                                required: true,*/}
                                        {/*                                type: 'email',*/}
                                        {/*                            },*/}
                                        {/*                        ]}*/}
                                        {/*                    >*/}
                                        {/*                        <Input/>*/}
                                        {/*                    </Form.Item>*/}
                                        {/*                </div>*/}
                                        {/*                <div*/}
                                        {/*                    className={'col-12 col-md-6'}>*/}
                                        {/*                    <Form.Item*/}
                                        {/*                        name={'tckn'}*/}
                                        {/*                        label="TC Kimlik Numaranız"*/}
                                        {/*                        rules={[*/}
                                        {/*                            () => ({*/}
                                        {/*                                required: true,*/}
                                        {/*                                message: 'TC Kimlik Numaranız numaranız gerekli bir alan',*/}
                                        {/*                                validator(*/}
                                        {/*                                    _, value) {*/}
                                        {/*                                    const v = HelperGeneral.telephoneClear(*/}
                                        {/*                                        value)*/}
                                        {/*                                    if (v.length ===*/}
                                        {/*                                        11) {*/}
                                        {/*                                        return Promise.resolve()*/}
                                        {/*                                    }*/}
                                        {/*                                    return Promise.reject(*/}
                                        {/*                                        new Error(*/}
                                        {/*                                            trans(*/}
                                        {/*                                                't10')))*/}
                                        {/*                                },*/}
                                        {/*                            })]}*/}
                                        {/*                    >*/}
                                        {/*                        <MaskedInput*/}
                                        {/*                            mask={'11111111111'}*/}
                                        {/*                        />*/}
                                        {/*                    </Form.Item>*/}
                                        {/*                </div>*/}
                                        {/*            </div>*/}

                                        {/*        </Panel>*/}
                                        {/*    )*/}
                                        {/*}*/}

                                        <Panel
                                            header={"Adrese Teslim"}
                                            key={"2"}
                                            // extra={collapseTitleRight((settings?.price ? (settings?.name ?? '-') + " - " + HelperGeneral.formatMoneyTL(settings?.price) : ''), 2)}
                                            extra={collapseTitleRight((settings?.price ? (settings?.name ?? '-') : ''), 2)}
                                        >
                                            <p>Siparişiniz belirteceğiniz adrese kargolanır.</p>
                                            {addressList()}
                                        </Panel>
                                    </Collapse>
                                </div>
                                {/*{*/}
                                {/*    DeliveryType === 2 && (*/}
                                {/*        <Col xs={12}>*/}
                                {/*            <div className={'box invoice-box'}>*/}
                                {/*                <h2>Fatura Adresi</h2>*/}
                                {/*                <Row>*/}
                                {/*                    <Col xs={12} className={invoiceChecked ? 'mb-0' : 'mb-4'}>*/}
                                {/*                        <Checkbox*/}
                                {/*                            checked={invoiceChecked}*/}
                                {/*                            onChange={() => {*/}
                                {/*                                setInvoiceChecked(!invoiceChecked)*/}
                                {/*                                setSelectedInvoiceAddress(null)*/}
                                {/*                            }}*/}
                                {/*                        >*/}
                                {/*                            Fatura adresim, teslimat adresim ile aynı*/}
                                {/*                        </Checkbox>*/}
                                {/*                    </Col>*/}
                                {/*                </Row>*/}
                                {/*                {addressList(true)}*/}
                                {/*            </div>*/}
                                {/*        </Col>*/}
                                {/*    )*/}
                                {/*}*/}
                            </Col>
                            <Col xs={12} md={4}>
                                <div className={'box'}>
                                    <h2>Sipariş özeti</h2>
                                    <BasketList price={settings?.price} basketView={true}/>
                                    {
                                        basketList?.products?.length > 0 && (
                                            <>
                                                <Row>
                                                    <Col xs={8} className={'d-flex align-items-center justify-content-start'}>
                                                        Toplam Harcanacak Puan
                                                    </Col>
                                                    <Col xs={4} className={'d-flex align-items-center justify-content-end'}>
                                                        {BasketInfo.getBasketTotalPoint()} puan
                                                    </Col>
                                                </Row>
                                                {/*{*/}
                                                {/*    DeliveryType !== undefined && (*/}
                                                {/*        <>*/}
                                                {/*            <hr/>*/}
                                                {/*            <Row>*/}
                                                {/*                <Col xs={8} className={'d-flex align-items-center justify-content-start'}>*/}
                                                {/*                    {DeliveryType === 1 && 'Eczaneden Teslim'}*/}
                                                {/*                    {DeliveryType === 2 && 'Adrese Teslim ' + '(' + (settings?.name ?? '-') + ')'}*/}
                                                {/*                </Col>*/}
                                                {/*                <Col xs={4} className={'d-flex align-items-center justify-content-end'}>*/}
                                                {/*                    {DeliveryType === 1 && HelperGeneral.formatMoneyTL(0)}*/}
                                                {/*                    /!*{DeliveryType === 2 && (settings?.price ? HelperGeneral.formatMoneyTL(settings?.price) : '-')}*!/*/}
                                                {/*                    {DeliveryType === 2 && (settings?.price ? HelperGeneral.formatMoneyTL(0) : '-')}*/}
                                                {/*                </Col>*/}
                                                {/*            </Row>*/}
                                                {/*            <hr/>*/}
                                                {/*        </>*/}
                                                {/*    )*/}
                                                {/*}*/}
                                                {/*{*/}
                                                {/*    DeliveryType !== undefined && (*/}
                                                {/*        <>*/}
                                                {/*            <Row>*/}
                                                {/*                <Col xs={7}>*/}
                                                {/*                    <Row>*/}
                                                {/*                        <Col xs={12}>Toplam ödenecek tutar</Col>*/}
                                                {/*                        <Col*/}
                                                {/*                            xs={12}*/}
                                                {/*                            style={{*/}
                                                {/*                                fontSize: 14,*/}
                                                {/*                                color: '#fbbda0',*/}
                                                {/*                            }}*/}
                                                {/*                        >*/}
                                                {/*                            (KDV dahil)*/}
                                                {/*                        </Col>*/}
                                                {/*                    </Row>*/}
                                                {/*                </Col>*/}
                                                {/*                <Col xs={5} className={'d-flex align-items-center justify-content-end'}>*/}
                                                {/*                    <h2 className={'m-0'}>*/}
                                                {/*                        {DeliveryType === 1 && HelperGeneral.formatMoneyTL(0)}*/}
                                                {/*                        {DeliveryType === 2 && (settings?.price ? HelperGeneral.formatMoneyTL(settings?.price) : '')}*/}
                                                {/*                    </h2>*/}
                                                {/*                </Col>*/}
                                                {/*            </Row>*/}
                                                {/*        </>*/}
                                                {/*    )*/}
                                                {/*}*/}
                                                <Row>
                                                    <Col xs={12}>
                                                        {
                                                            DeliveryType === 1 && (
                                                                <Form.Item>
                                                                    <Button
                                                                        type={"primary"}
                                                                        htmlType={"submit"}
                                                                        className={'btn text-white btn-primary mt-3 mb-0 w-100 h-25'}
                                                                        disabled={DeliveryType === 0 || isNaN(DeliveryType) ? true : false}
                                                                    >
                                                                        Siparişi Tamamla
                                                                    </Button>
                                                                </Form.Item>
                                                            )
                                                        }
                                                        {
                                                            DeliveryType === 2 && (
                                                                <Form.Item className={'m-0'}>
                                                                    <Button
                                                                        type={"primary"}
                                                                        htmlType={"submit"}
                                                                        onClick={() => {
                                                                            if (DeliveryType === 2) {
                                                                                return onFinishStep1()
                                                                            }
                                                                            return false
                                                                        }}
                                                                        className={'btn text-white btn-primary mt-3 mb-0 w-100 h-25'}
                                                                        disabled={DeliveryType === 0 || isNaN(DeliveryType) ? true : false}
                                                                    >
                                                                        {/*Ödeme Bilgilerine Geç*/}
                                                                        Hediyeyi Al
                                                                    </Button>
                                                                </Form.Item>
                                                            )
                                                        }
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Form>
                )
            }
            {
                step === 1 && (
                    <Row>
                        <Col xs={12} md={8}>
                            <div className={'box'}>
                                <h2>Ödeme Seçenekleri</h2>
                                <CreditCardForm setStep={setStep}/>
                            </div>
                        </Col>
                        <Col xs={12} md={4}>
                            <div className={'box'}>
                                <h2>Sipariş özeti</h2>
                                <BasketList basketEdit={false} price={settings?.price}/>
                            </div>
                        </Col>
                    </Row>
                )
            }
            {
                step === 2 && (
                    <Row>
                        <Col xs={12}>
                            <div className={'box success-result-box'}>
                                {
                                    paymentErrorMessage === null ? (
                                        <Result
                                            status={"success"}
                                            title={"Hediye Siparişiniz Başarıyla Oluştu"}
                                            subTitle={`Sipariş numaranız: ${orderNumber ?? '-'}`}
                                            extra={[
                                                <>
                                                    <div className={"ant-result-subtitle mb-3"}>
                                                        Siparişlerinizi <Link to={'/hesabim/siparislerim'} className={'my-orders-basket-link'}><b>siparişlerim</b></Link> sayfasından takip edebilirsiniz.
                                                    </div>
                                                    <Button type={"primary"} key={"console"} href={"/"}>
                                                        Ana Sayfaya Dön
                                                    </Button>
                                                </>
                                            ]}
                                        />
                                    ) : (
                                        <Result
                                            status={"error"}
                                            title={paymentErrorMessage}
                                            subTitle={""}
                                            extra={[
                                                <Button type={"primary"} key={"console"} href={"/"}>
                                                    Ana Sayfaya Dön
                                                </Button>
                                            ]}
                                        />
                                    )
                                }
                            </div>
                        </Col>
                    </Row>
                )
            }
            {
                step === 3 && ( // Eczane işlem sonucu
                    <div className={'row'}>
                        <div className={'col-12'}>
                            <div className={'box'}>
                                <div className={"row"}>
                                    <div className={"col-12 col-md-9 mx-auto"}>
                                        <Result
                                            status="success"
                                            title="Siparişiniz başarıyla alınmıştır"
                                            subTitle={'Eczane siparişinizi onayladığında, sms olarak gönderilecek teslimat numaranız ile hediyenizi teslim alabilirsiniz. Onay durumunu siparişlerim menüsünden takip edebilirsiniz.'}
                                            //subTitle={'Teslimat Numaranız: ' + deliveryInfo?.deliveryCode}
                                            extra={[
                                                <>
                                                    <div className="ant-result-subtitle mb-3 d-none">Siparişlerinizi, siparişlerim
                                                        sayfasından takip edebilirsiniz.
                                                    </div>
                                                    <Button type="primary" key="console" href={"/hesabim/siparislerim"}>
                                                        Siparişlerine Dön
                                                    </Button>
                                                </>
                                            ]}
                                        />
                                    </div>
                                </div>

                                <h4>Teslimat Bilgileri</h4>
                                <div className={"row p-3"}>
                                    <div
                                        className={"col-12 "}>
                                        <b>Eczane Bilgisi</b></div>
                                    <hr/>
                                    <div
                                        className={"col-12 "}>
                                        <div className={"row"}>
                                            <div className={"col-12 col-md-3"}>
                                                <b>Adı : </b>
                                            </div>
                                            <div className={"col-12 col-md-9"}>
                                                {deliveryInfo?.deliveryInfo?.accountDetail?.accountName}
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-12 col-md-3"}>
                                                <b>Adresi : </b>
                                            </div>
                                            <div className={"col-12 col-md-9"}>
                                                {deliveryInfo?.deliveryInfo?.accountDetail?.addressLine}
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-12 col-md-3"}>
                                                <b>Telefon Numarası : </b>
                                            </div>
                                            <div className={"col-12 col-md-9"}>
                                                {deliveryInfo?.deliveryInfo?.accountDetail?.phoneNumber}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={"row p-3"}>
                                    <div
                                        className={"col-12 "}>
                                        <b>Alıcı Bilgisi</b></div>
                                    <hr/>
                                    <div
                                        className={"col-12 "}>
                                        <div className={"row"}>
                                            <div className={"col-12 col-md-3"}>
                                                <b>Adı : </b>
                                            </div>
                                            <div className={"col-12 col-md-9"}>
                                                {deliveryInfo?.deliveryInfo?.receiverName} {deliveryInfo?.deliveryInfo?.receiverSurname}
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-12 col-md-3"}>
                                                <b>Telefon Numarası : </b>
                                            </div>
                                            <div className={"col-12 col-md-9"}>
                                                {deliveryInfo?.deliveryInfo?.receiverPhone}
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-12 col-md-3"}>
                                                <b>E-posta Adresi : </b>
                                            </div>
                                            <div className={"col-12 col-md-9"}>
                                                {deliveryInfo?.deliveryInfo?.receiverEmail}
                                            </div>
                                        </div>
                                        <div className={"row"}>
                                            <div className={"col-12 col-md-3"}>
                                                <b>Kimlik Numarası : </b>
                                            </div>
                                            <div className={"col-12 col-md-9"}>
                                                {deliveryInfo?.deliveryInfo?.receiverIdentityNumber}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className={"row p-3"}>
                                    <div
                                        className={"col-12 "}>
                                        <b>Ürün Bilgisi</b></div>
                                    <hr/>

                                    {
                                        deliveryInfo?.productDetails &&
                                        deliveryInfo?.productDetails.length > 0 && (
                                            deliveryInfo?.productDetails.map((v2, i2) => (
                                                <div className={"row p-3 pl-0 "}>
                                                    <div
                                                        className={"col-12 col-md-2 d-flex justify-content-start align-items-center"}>
                                                        <img
                                                            src={v2?.imageUrl}
                                                            className={'img-thumbnail'}
                                                            style={{
                                                                width: '100%',
                                                                maxHeight: 70,
                                                                objectFit: 'cover'
                                                            }}/>
                                                    </div>
                                                    <div
                                                        className={"col-12 col-md-10 d-flex justify-content-start align-items-center"}>
                                                        <div className={"row"}>
                                                            <div className={"col-12"}>
                                                                {v2?.productName}
                                                            </div>
                                                            <div className={"col-12"}>
                                                                <b>{v2?.quantity} Adet</b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        )

                                    }
                                </div>


                            </div>
                        </div>

                    </div>
                )
            }

            {
                addressShow && (
                    <AddressModal
                        show={addressShow}
                        showSend={(show) => {
                            setAddressShow(show)
                        }}
                        getAddress={getAddress}
                        item={addressItem}
                    />
                )
            }
        </Container>
    )
}

const mapStateToProps = (state, ownProps) => ({
    basketList: state.BasketReducer.basketList,
    settings: state.GeneralReducer.settings,
})

export default withRouter(connect(mapStateToProps)(BasketView))
